module.exports = __webpack_public_path__ + "img/icon-style-bg-rounded-xl.df1a6ff.png";